import _Model from "./_Model";

export default class IOType extends _Model {
  constructor(json) {
    super(json);
    this.id = IOType.getOrDefault(json, 'id', '');
    this.text = IOType.getOrDefault(json, 'text', '');
    this.ioGroup = IOType.getOrDefault(json, 'ioGroup', '');
  }

}
